import { combineReducers } from 'redux';

import AuthReducer from './AuthReducer';
import GeneralReducer from './GeneralReducer';
import CategoriesReducer from './CategoriesReducer';
import StoreReducer from './StoreReducer';
import activeCleanersReducer from './ActiveCleanersReducer';
import CustomerReducer from './CustomerReducer';
import WorkOrderRequestReducer from './WorkOrderRequestReducer';
import JobDetailsReducer from './JobDetailsReducer';
import SubscriptionReducer from './SubscriptionReducer';
import PaymentCardsReducer from './PaymentCardsReducer';
import CheckListReducer from './CheckListReducer';
import ActiveJobsReducer from './ActiveJobsReducer';
import ActiveAndPastJobDetailsReducer from './ActiveAndPastJobDetailsReducer';
import ChatReducer from './ChatReducer';
import ScheduleReducer from './ScheduleReducer';
import JobReducer from './JobReducer';
import CleanerTaskSummaryReducer from './CleanerTaskSummaryReducer';
import TimeSheetReducer from './TimeSheetReducer';
import LocationReducer from './LocationReducer';
import WeeklyInspectionReducer from './WeeklyInspectionReducer';
import ProblemReportingReducer from './ProblemReportingReducer';
import EditChecklistReducer from './EditChecklistReducer';
import CustomerCleanerReducer from './CustomerCleanerReducer';
import TimeINTimeOUTReducer from './TimeINTimeOUTReducer';
import AlertReducer from './AlertReducers'
import CompanyReducer from './CompanyReducer'

export const Reducer = combineReducers({
  AuthReducer,
  GeneralReducer,
  CategoriesReducer,
  CustomerReducer,
  activeCleanersReducer,
  StoreReducer,
  WorkOrderRequestReducer,
  JobDetailsReducer,
  PaymentCardsReducer,
  CheckListReducer,
  SubscriptionReducer,
  JobReducer,
  CleanerTaskSummaryReducer,
  ChatReducer,
  ScheduleReducer,
  TimeSheetReducer,
  LocationReducer,
  ActiveJobsReducer,
  ActiveAndPastJobDetailsReducer,
  ProblemReportingReducer,
  WeeklyInspectionReducer,
  EditChecklistReducer,
  CustomerCleanerReducer,
  TimeINTimeOUTReducer,
  AlertReducer,
  CompanyReducer
});
